import { AdminPanelTopic } from "../../components/TopicsPanel/types";
import { updateTopic } from "../../services/patch";
import { createTopic } from "../../services/post";
import { Topic } from "../ConfigContext/types";

export const useTopicHandlers = (setTopics: React.Dispatch<React.SetStateAction<AdminPanelTopic[]>>) => {
  const handleTopics = {
    add: async (topicName: string): Promise<void> => {
      try {
        const response = await createTopic(topicName);
        const newTopic: AdminPanelTopic = { id: response.result, name: topicName, labels: [], scraperConfigs: [] };
        if (newTopic.id) {
          setTopics((prevTopics) => [newTopic, ...prevTopics]);
        }
      } catch (error) {
        console.error("Error adding new topic:", error);
      }
    },
    update: async (updatedTopic: Topic): Promise<void> => {
      try {
        const response = await updateTopic({ id: updatedTopic.id, name: updatedTopic.name });
        if (response) {
          setTopics((prevTopics) =>
            prevTopics.map((t) => (t.id === updatedTopic.id ? { ...t, name: updatedTopic.name } : t))
          );
        }
      } catch (error) {
        console.error("Error updating new topic:", error);
      }
    },
  };

  return { handleTopics };
};
